export default from './CookiesPolicy';



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/CookiesPolicy/index.js